import UnderConstruction from "../common/UnderConstruction";

export default function InventoryReports() {
  return <UnderConstruction title="Inventory Reports" />;
}
